import MultisearchView from './View'

export default function install(Vue) {
  Vue.component('SearchV2View', MultisearchView)
}
